import { useQuery } from '@tanstack/react-query';

import { api } from '@shared/api/client';
import { key, STALE_TIME } from '@shared/api/query-keys';

import { toCaseDetail, type CaseId, type WireCaseDetail } from '../_shared/types';

/**
 * One case, its facts, and its thread.
 *
 * `staleTime` is `0`: this is a detail route whose two acts — a reply and a
 * state move — both change what it shows, and a cached answer would render the
 * state the operator just left rather than the one they just created.
 *
 * The key is the same tuple the report entry registers, because it is the same
 * record read from a different surface: one case, two depths, one cache entry.
 */
export function caseKey(caseId: CaseId) {
  return key('support', 'case', caseId);
}

export function useCase(caseId: CaseId) {
  return useQuery({
    queryKey: caseKey(caseId),
    queryFn: async () => toCaseDetail(await api.get<WireCaseDetail>('support', `/admin/cases/${caseId}`)),
    staleTime: STALE_TIME.detail,
  });
}
